import axios from 'axios';
import { articleFallbackData } from '../components/data/articleFallbackData';

const validateToken = async () => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/get-auth-strapi`);
    return response.data;
}

export const getArticles = async () => {
    try {
        const data = await validateToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        const response = await axios.get(`${process.env.REACT_APP_STRAPI_BASE_URL}/api/posts?status=published&sort[0]=createdAt:desc&pagination[pageSize]=8&pagination[page]=1&filters[frontend_status][$eq]=published&fields[0]=title&fields[1]=slug&fields[2]=excerpt&populate[categories][fields][0]=name&populate[categories][fields][1]=slug&populate=featured_image&fields[5]=content`);
        return Array.isArray(response.data?.data) ? response.data.data : articleFallbackData;
    } catch (error) {
        console.error('Error fetching articles:', error);
        return articleFallbackData;
    }
}